<template>
    <ContainerLayout page="4" :loading="loading">
        <div class="content p-1">
            <div class="d-flex flex-column">
                <div class="mb-3">
                    <div class="d-flex flex-row justify-content-between align-items-center" @click.prevent="goToProfile()"
                        style="cursor: pointer;">
                        <div class="d-flex flex-row align-items-center">
                            <img id="profile-img" class="profile-img" src="//ssl.gstatic.com/accounts/ui/avatar_2x.png" />
                            <div class="d-flex flex-column ml-3">
                                <span class="font-weight-bold">{{ currentUser ? currentUser.name : '' }}</span>
                                <small>{{ currentUser ? currentUser.email : '' }}</small>
                            </div>
                        </div>
                        <div class="d-flex flex-row align-items-center">
                            <font-awesome-icon icon="chevron-right" />
                        </div>
                    </div>
                    <hr style="visibility: hidden;">
                </div>
                <div class="mb-3">
                    <div class="d-flex flex-row justify-content-between align-items-center" @click.prevent="goToCompany()"
                        style="cursor: pointer;">
                        <div class="d-flex flex-row align-items-center">
                            <span style="font-weight: 600;">{{ $t('Your Company') }}</span>
                        </div>
                        <div class="d-flex flex-row align-items-center">
                            <font-awesome-icon icon="chevron-right" />
                        </div>
                    </div>
                    <hr>
                </div>
                <div class="mb-3">
                    <div class="d-flex flex-row justify-content-between align-items-center" @click.prevent="goToLanguage()"
                        style="cursor: pointer;">
                        <div class="d-flex flex-row align-items-center">
                            <span style="font-weight: 600;">{{ $t('Language') }}</span>
                        </div>
                        <div class="d-flex flex-row align-items-center">
                            <font-awesome-icon icon="chevron-right" />
                        </div>
                    </div>
                    <hr>
                </div>
                <div class="mb-3">
                    <div class="d-flex flex-row justify-content-between align-items-center"
                        @click.prevent="goToChangePassword()" style="cursor: pointer;">
                        <div class="d-flex flex-row align-items-center">
                            <span style="font-weight: 600;">{{ $t('Change Password') }}</span>
                        </div>
                        <div class="d-flex flex-row align-items-center">
                            <font-awesome-icon icon="chevron-right" />
                        </div>
                    </div>
                    <hr>
                </div>
                <div class="mb-3">
                    <div class="d-flex align-items-center">
                        <button class="btn btn-outline-main w-100" style="font-weight: 600;" @click.prevent="logout()">{{
                            $t('Logout') }}</button>
                    </div>
                </div>
            </div>
        </div>
    </ContainerLayout>
</template>
  
<script>
import ContainerLayout from "../ContainerLayout.vue";
import AuthService from "@/services/auth.service";

export default {
    name: "ProfileIndex",
    computed: {
        currentUser() {
            return localStorage.getItem('loggedData') ? JSON.parse(localStorage.getItem('loggedData')).user : null;
        },

        currentCompany() {
            return localStorage.getItem('loggedData') ? JSON.parse(localStorage.getItem('loggedData')).user.company : null;
        },
    },
    data() {
        return {
            loading: false,
        };
    },
    components: {
        ContainerLayout
    },
    created() {
        this.loading = true;
        let loader = this.$loading.show();

        // wait 1 second and hide
        setTimeout(() => {
            this.loading = false;
            loader.hide();
        }, 500);
    },
    methods: {
        logout() {
            this.$store.dispatch("auth/logout");
            this.$router.push("/login");
        },

        goToCompany() {
            if (this.currentCompany) {
                this.$router.push("/profile/company");
            } else {
                this.$router.push("/company-registration");
            }
        },

        goToProfile() {
            this.$router.push("/profile/detail");
        },

        goToLanguage() {
            this.$router.push("/profile/language");
        },

        goToChangePassword() {
            this.loading = true;
            let loader = this.$loading.show();

            AuthService
                .changePassword(this.currentUser)
                .then((response) => {
                    this.loading = false;
                    loader.hide();

                    if (response.data.status == "success") {
                        this.$router.push({
                            name: "Password",
                            query: {
                                resetToken: response.data.data,
                                changePassword: true,
                            },
                        });
                    } else {
                        this.$vueAlert.alert(response.data.message, null, 'error');
                    }
                })
                .catch((error) => {
                    this.loading = false;
                    loader.hide();

                    let errorMessage = this.$t('An error occurred');
                    if (error.response) {
                        if (error.response.status == 401) {
                            this.$store.dispatch("auth/logout");
                            this.$router.push('/login');
                            return; // Exit the function after handling 401
                        }

                        // Check if the message is available in the error response
                        if (error.response.data && error.response.data.message) {
                            errorMessage = error.response.data.message;
                        } else if (error.response.statusText) {
                            // Fallback to statusText if message is not available
                            errorMessage = error.response.statusText;
                        }
                    } else if (error.message) {
                        // Fallback to error.message if response is not available
                        errorMessage = error.message;
                    }

                    this.$vueAlert.alert(errorMessage, null, 'error');
                });
        }
    }
};
</script>
  